module.exports = __webpack_public_path__ + "img/fm.52297de2.svg";